import { FC, Fragment, createPortal } from "preact/compat";
import { Dialog, Transition } from "@headlessui/react";
import { usePortalTarget } from "~/hooks";
import { BackdropProps } from "./interfaces";
import cn from "classnames";

const Backdrop: FC<BackdropProps> = ({
    show,
    children,
    rect,
    className,
    zIndex = 100,
    beforeEnter,
    afterEnter,
    beforeLeave,
    afterLeave,
}) => {
    const target = usePortalTarget("backdrop");

    if (!target.value) {
        return null;
    }

    return createPortal(
        <Transition
            appear
            show={show.value}
            beforeEnter={beforeEnter}
            afterEnter={afterEnter}
            beforeLeave={beforeLeave}
            afterLeave={afterLeave}
        >
            <Dialog onClose={() => (show.value = false)}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-200"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div
                        className="fixed inset-0 bg-neutral-400/60 backdrop-blur"
                        style={{ zIndex }}
                    />
                </Transition.Child>
                <Transition.Child
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="transition ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                >
                    <Dialog.Panel
                        className={cn("fixed", className)}
                        style={{
                            ...rect.value,
                            zIndex,
                        }}
                    >
                        {children}
                    </Dialog.Panel>
                </Transition.Child>
            </Dialog>
        </Transition>,
        target.value,
    );
};

export default Backdrop;
